














import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Phone extends Vue {
  public async mounted() {
    this.loadNumber();
  }
  private async loadNumber() {
    const area = '416';
    const phoneOne = '871';
    const phoneTwo = '8564';
    const phoneNumberElement = this.$refs.number as Element;
    phoneNumberElement.innerHTML = `(${area}) ${phoneOne}-${phoneTwo}`;
  }
}
